import z from 'zod';
import { dontPreprocessStringForZod } from '../../utils';
import { rabbitmqUrl } from '../../utils/string';

export const rabbitmqUrlsSchema = dontPreprocessStringForZod(
  z.preprocess((value: any) => {
    const url = new URL(value);
    const hosts = url.hostname.split(',');
    return hosts.map(host => {
      return `amqp://${url.username}:${url.password}@${host}:${url.port}${url.pathname}`;
    });
  }, z.array(rabbitmqUrl)),
);
